module.exports = {
  // 顶部导航
  Header: {
    bookcount: "共",
    bookcount2: "本书",
    lookcount: "浏览量",
    homePage: "书展首页",
    bookList: "我的书单",
    record: "选书记录",
    userManual:"使用手册",
    logOut: "登出",
  },
  // 首页标语
  slogan: "创新、诚信、服务、求实",
  // 首页表单
  SearchBoxForm: {
    keyword: "关键字",
    isbn: "ISBN",
    pubyear: "出版年",
    pub: "出版社",
    title: "题名",
    searchTips: "请输入检索内容",
    search: "搜索",
    coRetrieval: "点击按分类搜索 (共检索到 ",
    coRetrieval2: " 本书)",
    coRetrieval3: "共检索到 ",
    coRetrieval4: " 本书",
    exportSearchBook:"下载",
  },
  // 列表项组件
  BookItem: {
    ISBN: "ISBN",
    Binding: "装帧",
    pages: "页数",
    Price: "价格",
    SupplyStatus: "供货信息",
    add: "加入书单",
  },
  // 二级树组件
  TreeBoxTip: "按分类搜索：",
  // 提示信息
  PromptInfo: {
    emptyContent: "输入内容为空，请检查！",
    message:
      "尊敬的用户您好，在使用移动设备时建议将屏幕横置，以获得更好的阅览体验。",
    Warn: "警告",
    logoutText: "登出后将会",
    logoutText2: "完全删除",
    logoutText3: "我的书单内书籍信息，登出前请务必将书单导出备份。",
  },
  // 书单相关提示信息
  BooklistInfo: {
    okText: "确认",
    cancelText: "取消",
    AppendTitle: "是否继续追加？",
    AppendInfo: "检测到书单中存在一本或多本《",
    AppendInfo2: "》是否继续追加？",
    AppendInfo3: "已将《",
    AppendInfo4: "》加入至我的书单。",
    AppendInfo5: "放弃追加《",
    AppendInfo6: "》",
    AppendInfo7: "》移除我的书单。",
  },
  // 图书详情
  details: {
    Category: "类别：",
    Publisher: "出版社：",
    Binding: "装帧：",
    Pages: "页数：",
    CLCNumber: "中图分类号：",
    ISBN: "ISBN：",
    Availability: "供货状态：",
    Price: "价格：",
    add: "加入我的书单 +",
    IntroductionInfo: "图书简介",
    AwardInfo: "获奖信息",
    CollectionInfo: "馆藏信息",
  },
  // 我的书单
  bookList: {
    Details: "详情",
    Delete: "删除",
    Export: "导出",
    Excel: "导出书单至本地（Excel表格）",
    Upload: "上传我的选书清单",
    Upload2: "上传书单",
    Name: "姓名",
    Name2: "请输入姓名",
    Telephone: "电话",
    Telephone2: "请输入号码",
    Telephone3: "请输入正确的手机/固定电话号码",
    Telephone4: "请输入移动/固定电话号码",
    Mail: "邮箱",
    Mail2: "请输入邮箱",
    Mail3: "邮箱格式有误，请检查！",
    Faculty: "院系/研究所",
    Faculty2: "请输入院系/研究所",
    Type: "身份类型",
    Type2: "请选择身份类型",
    Student: "证件号",
    Student2: "请输入学/工/读者证/微信号",
    Reason: "推荐理由/课题名称",
    Reason2: "请输入推荐理由/课题名称",
    Reason3: "推荐/采购理由",
    Submit: "提交书单",
    Submit2: "书单已经成功提交至云端！",
    Submit3: "书单为空，无法上传书单！",
  },

  //图片上传界面
  uploadImage:{
    Name:"姓名",
    Department:"院系/专业",
    UserID:"学号/工号",
    PatronType:"读者类型",
    Faculty:"学院",
    BookImage:"选书图片",
    NameOption:"请输入姓名",
    DepartmentOption:"请输入院系/专业",
    UserIDOption:"请输入学号/工号",
    PatronTypeOption:"请输入读者类型",
    FacultyOption:"请输入学院",
    BookImageOption:"请输入选书图片",
    SubmitBtn:"提交"
  },
  //身份类型
  types:{
    Teacher: "教师" ,
    Student: "学生",
    doctor:"博士",
    master:"硕士",
    Administrators:"管理人员",
    Research: "研究员",
    Research1: "副研究员",
    Research2: "助理研究员",
    Others: "其他"
  },
  // 表格
  table: {
    Cover: "封面",
    BookTitle: "书名",
    Author: "作者",
    PublishingHouse: "出版社",
    Category: "类别",
    ISBN: "ISBN",
    CLCnumber: "中图分类号",
    Framing: "装帧",
    Pages: "页数",
    Currency: "币制",
    Price: "价格",
    Availability: "供货状态",
    Operate: "操作",
    NumberOfResults: "结果数：",
    TheTotalNumberOfSelectedBooks: "选书总数量：",
    ExportAllRecords:"导出所有记录"
  },
  // 404页面
  404: {
    title: "生活总归带点荒谬，你说是吧。",
    BackToHome: "返回首页",
  },
  // 页脚
  footer:{
    Copywriting:"自2022年免费线上书展",
    officialWeb:"公司官网",
    copyright:"版权所有 © 中国科技资料进出口有限责任公司",
    beian1:"京ICP备06062204号京",
    baian2:"公网安备 11010802039466号"
  },
  // 使用手册
  userManual:{
    Step_1:'第一步：用户可根据自己需求筛选图书，可直接这直接检索，也可以通过分类进行筛选',
    Step_2:'第二步：选择图书加入书单，并且可通过观看我的书单可以查询选书记录',
    Step_3:'第三步：上传清单，并填写所需信息即可',
  }
};
